import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { UserPosts } from 'shared/models';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type TUserPostStore = { [key: string]: PromiseOrValue<UserPosts> | undefined };

export const $UserPostStore = atom({} as TUserPostStore);

export const $UserPost = safeAtomFamily((userLinkName: string) => {
  const a = atom(
    (get) => {
      const data = get($UserPostStore)[userLinkName];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: PromiseOrValue<UserPosts>) => {
      const old = get($UserPostStore);
      set($UserPostStore, { ...old, [userLinkName]: input });
    },
  );

  a.debugLabel = `$UserPost+${encodeURIComponent(userLinkName)}`;

  return a;
});
